"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var PendingIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.25 13.383v.233H7.117a1.25 1.25 0 010-2.5h3.633V7.25a1.25 1.25 0 012.5 0v6.133zM12.955 1c5.609.51 10 5.222 10 10.954 0 6.072-4.928 11-11.01 11-5.736 0-10.44-4.396-10.945-10h2.536c.494 4.21 4.07 7.478 8.409 7.478 4.688 0 8.488-3.797 8.488-8.478 0-4.339-3.266-7.919-7.478-8.418V1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.99 1.045V3.58c-.8.094-1.566.3-2.282.602l-1.27-2.199a10.91 10.91 0 013.552-.94z",
    opacity: ".8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.694 2.982l1.268 2.196A8.522 8.522 0 005.23 6.893L3.033 5.624c.73-1.025 1.63-1.92 2.661-2.642z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.022 7.361L4.218 8.63a8.429 8.429 0 00-.636 2.361H1.046a10.94 10.94 0 01.976-3.629z",
    opacity: ".4"
  })));
});
PendingIcon.category = 'Time';
var _default = PendingIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/PendingIcon.js
// module id = 1126
// module chunks = 0